// Updated Header.jsx
import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import Modal from "../Modal/Modal"; // Import the modal component

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProductsDropdownOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setProductsDropdownOpen(false);
  };

  const toggleProductsDropdown = () => {
    setProductsDropdownOpen(!productsDropdownOpen);
  };

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleProductsClick = (e) => {
    e.preventDefault();
    toggleProductsDropdown();
  };

  return (
    <>
      <header className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="container">
          <a href="#/" className="logo">
            <img
              src="/assets/images/logo_avvoka.png"
              alt="Avvoka Exports"
              className="logo-image"
            />
          </a>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <ul>
              <li>
                <a href="#/" onClick={closeMenu}>
                  Home
                </a>
              </li>
              <li>
                <a href="#about" onClick={closeMenu}>
                  About
                </a>
              </li>
              <li className="nav-item-with-dropdown" ref={dropdownRef}>
                <a
                  href="#products"
                  onClick={handleProductsClick}
                  className={`dropdown-toggle ${
                    productsDropdownOpen ? "active" : ""
                  }`}
                >
                  Products
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="dropdown-chevron"
                  >
                    <path
                      d="M6 9L12 15L18 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
                <div
                  className={`dropdown-menu ${
                    productsDropdownOpen ? "show" : ""
                  }`}
                >
                  <div className="dropdown-content">
                    <div className="dropdown-section">
                      <h4>Fresh Produce</h4>
                      <a
                        href="#/products/fresh-produce/vegetables"
                        onClick={closeMenu}
                      >
                        Vegetables
                      </a>
                      <a
                        href="#/products/fresh-produce/fruits"
                        onClick={closeMenu}
                      >
                        Fruits
                      </a>
                      <a
                        href="#/products/fresh-produce/herbs"
                        onClick={closeMenu}
                      >
                        Herbs & Spices
                      </a>
                    </div>
                    <div className="dropdown-section">
                      <h4>Beverages</h4>
                      <a href="#/products/coffee/all" onClick={closeMenu}>
                        All Coffee
                      </a>
                      <a href="#/products/tea/all" onClick={closeMenu}>
                        Black Tea
                      </a>
                    </div>
                    <div className="dropdown-section">
                      <h4>Nuts & Others</h4>
                      <a
                        href="#/products/nuts-others/macadamia"
                        onClick={closeMenu}
                      >
                        Macadamia Nuts
                      </a>
                      <a
                        href="#/products/nuts-others/cashewnuts"
                        onClick={closeMenu}
                      >
                        Cashew Nuts
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <a href="#services" onClick={closeMenu}>
                  Services
                </a>
              </li>
              <li>
                <a href="#contact" onClick={closeMenu}>
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            {/* Updated Get Quote button to open modal */}
            <button className="btn btn-primary" onClick={openModal}>
              Get Quote
            </button>
            <button
              className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </header>

      {/* Modal component */}
      <Modal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default Header;
